import {keepPreviousData, queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getLedger} from './getLedger';

export const LEDGER_PAGE_SIZE = 25;

export const ledgerQueryOptions = (clinicId: string, page: number) =>
  queryOptions({
    queryKey: keys.ledger.list(clinicId, page),
    queryFn: () => getLedger(clinicId, page, LEDGER_PAGE_SIZE),
    enabled: clinicId !== '',
    /* Листая журнал, человек держит в голове остаток и прошлую строку.
       Без этого каждая страница сбрасывала бы вкладку в лоадер —
       вместе с карточкой баланса, которая не менялась. */
    placeholderData: keepPreviousData,
  });
